var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Gift component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconGift extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.7973 1.27902C7.47909 1.01384 7.00616 1.05684 6.74099 1.37504C6.47582 1.69325 6.51881 2.16618 6.83702 2.43135L9.92782 5.00702H3.41526C2.13906 5.00702 1.10449 6.04159 1.10449 7.31779V12.0001C1.10449 13.0138 1.75721 13.875 2.66528 14.1864V20.5842C2.66528 21.197 2.90874 21.7848 3.34209 22.2182C3.77544 22.6515 4.3632 22.895 4.97605 22.895H11.9852L11.9995 22.8951L12.0138 22.895H19.023C19.6358 22.895 20.2236 22.6515 20.6569 22.2182C21.0903 21.7848 21.3337 21.197 21.3337 20.5842V14.1864C22.2418 13.875 22.8945 13.0138 22.8945 12.0001V7.31779C22.8945 6.04159 21.8599 5.00702 20.5837 5.00702H14.0711L17.1619 2.43135C17.4801 2.16618 17.5231 1.69325 17.2579 1.37504C16.9928 1.05684 16.5198 1.01384 16.2016 1.27902L11.9995 4.78082L7.7973 1.27902ZM2.60449 7.31779C2.60449 6.87001 2.96749 6.50702 3.41526 6.50702H11.2495V12.8109H3.42963L3.41528 12.8107L3.40493 12.8108C2.96192 12.8053 2.60449 12.4444 2.60449 12.0001V7.31779ZM12.7495 12.8109V6.50702H20.5837C21.0315 6.50702 21.3945 6.87001 21.3945 7.31779V12.0001C21.3945 12.4444 21.0371 12.8053 20.5941 12.8108L20.5837 12.8107L20.5694 12.8109H12.7495ZM4.16528 14.3109H11.2495V21.395H4.97605C4.76102 21.395 4.5548 21.3095 4.40275 21.1575C4.2507 21.0054 4.16528 20.7992 4.16528 20.5842V14.3109ZM12.7495 14.3109V21.395H19.023C19.238 21.395 19.4442 21.3095 19.5963 21.1575C19.7483 21.0054 19.8337 20.7992 19.8337 20.5842V14.3109H12.7495Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconGift.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconGift.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconGift.prototype, "size", void 0);
if (customElements.get('cat-icon-gift') === undefined) {
    customElements.define('cat-icon-gift', BlocksIconGift);
}
